import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/trafficsigns/trafficsigns';

export default new class TrafficSignsModel {

  constructor() { }

  get(id) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, { id: id }));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll(force = false) {
    return new Promise((resolve, reject) => {
      // if (!localStorage.getItem('dataset_parkinglocations') || force) {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
      // } else {
      //   resolve(JSON.parse(localStorage.getItem('dataset_parkinglocations'))); 
      // }
    });
  }

  create(data) {
    return new Promise((resolve, reject) => {
      axios.post(BASE, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  remove(id) {
    return new Promise((resolve, reject) => {
      axios.delete(BASE + '/' + id, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  test(serialNumber, data) {
    return new Promise((resolve, reject) => {
      axios.post(BASE + '/' + serialNumber + '/test', data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  restart(serialNumber) {
    return new Promise((resolve, reject) => {
      axios.post(BASE + '/' + serialNumber + '/restart', null, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  update(serialNumber, data) {
    if (data.id !== undefined) {
      delete data.id;
    }
    return new Promise((resolve, reject) => {
      axios.put(BASE + '/' + serialNumber, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  message(serialNumber, data) {
    if (data.id !== undefined) {
      delete data.id;
    }
    return new Promise((resolve, reject) => {
      axios.post(BASE + '/' + serialNumber + '/message', data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/TrafficSignsModel.js